/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @author Aleksandr Perkhunov
 * @author Evgenij Tyan
 * @version 1.4.1
 * @since 1.0.0
 */
import styled from 'styled-components';

import { colors, fonts } from '../../../../../../../theme';

export const BasketLoaderContainer = styled.div.attrs({
    className: 'basket__loader',
})`
    position: relative;
    min-height: 200px;
    & .loader__frame {
        transform: translate(-50%, -50%);
    }
`;

export const BasketItemContainerStyled = styled.div.attrs({
    className: 'basket__item-container',
})<{ height: number }>`
    display: flex;
    flex-direction: column;
    min-height: ${props => props.height}px;
    max-height: 440px;
    overflow-y: auto;
    padding: 0 24px;
    background: ${colors.basketItemBg};

    .basket__item-label {
        min-width: 132px;
    }
`;

export const BasketItemStyled = styled.div.attrs(({ dataBasketItem }: { dataBasketItem?: string }) => ({
    'className': 'basket__item',
    'data-basket-item': dataBasketItem,
}))`
    display: flex;
    align-items: center;
    height: 44px;
    padding: 11px 10px;
    border-bottom: 1px solid ${colors.basketItemBorder};
    box-sizing: border-box;
    &:last-child {
        border-bottom: none;
    }
    & .basket__item-text_bold {
        ${fonts.textMainBold};
        line-height: 1;
        background: transparent;
    }
`;

export const BasketSearchNotFound = styled.div.attrs({
    className: 'basket__search-not-found',
})`
    padding: 10px;
`;
